import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import 'styles/main.css';

import Navbar   from 'components/Navbar';
import Footer   from 'components/Footer';

import HomePage  from 'pages/HomePage';
import ToolsPage from 'pages/ToolsPage';

// PDF Tools
import ImageToPDF  from 'pages/tools/pdf/ImageToPDF';
import PDFToWord   from 'pages/tools/pdf/PDFToWord';
import PDFCompress from 'pages/tools/pdf/PDFCompress';
import MergePDF    from 'pages/tools/pdf/MergePDF';
import SplitPDF    from 'pages/tools/pdf/SplitPDF';
import PDFToZip    from 'pages/tools/pdf/PDFToZip';
import PdfToJpg    from 'pages/tools/pdf/PdfToJpg';        // NEW

// Image Tools
import JpgToPng     from 'pages/tools/image/JpgToPng';
import ImageResize   from 'pages/tools/image/ImageResize';
import ImageCompress from 'pages/tools/image/ImageCompress';
import RemoveBg      from 'pages/tools/image/RemoveBg';
import PngToJpg      from 'pages/tools/image/PngToJpg';    // NEW

// Text Tools
import WordCounter   from 'pages/tools/text/WordCounter';
import CaseConverter from 'pages/tools/text/CaseConverter'; // NEW

// Utility Tools
import QrGenerator   from 'pages/tools/utility/QrGenerator';  // NEW
import ResumeBuilder from 'pages/tools/utility/ResumeBuilder'; // NEW

// Blog
import BlogPage   from 'pages/blog/BlogPage';
import BlogDetail from 'pages/blog/BlogDetail';

// Static pages
import AboutPage   from 'pages/static/AboutPage';
import ContactPage from 'pages/static/ContactPage';
import PrivacyPage from 'pages/static/PrivacyPage';
import TermsPage   from 'pages/static/TermsPage';
import FaqPage     from 'pages/static/FaqPage';

// Admin — completely hidden, not linked anywhere on the site
import AdminLogin     from 'pages/blog/AdminLogin';
import AdminDashboard from 'pages/blog/AdminDashboard';

// ScrollToTop — on every route change, scroll the window back to the top.
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

// Auth guard
function AdminRoute({ children }) {
  const token = localStorage.getItem('dl_token');
  return token ? children : <Navigate to="/dv-panel-83ca0bcf" replace />;
}

function NotFound() {
  return (
    <div className="not-found">
      <h1>404</h1>
      <h2>Page Not Found</h2>
      <p>The page you are looking for does not exist.</p>
      <a href="/" className="btn btn-primary">Go to Homepage</a>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="page-wrap">
        <Navbar />
        <main className="main">
          <Routes>
            {/* Public pages */}
            <Route path="/"      element={<HomePage />} />
            <Route path="/tools" element={<ToolsPage />} />
            <Route path="/blog"       element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogDetail />} />

            {/* Static pages */}
            <Route path="/about"   element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms"   element={<TermsPage />} />
            <Route path="/faq"     element={<FaqPage />} />

            {/* PDF Tools */}
            <Route path="/tools/pdf/image-to-pdf" element={<ImageToPDF />} />
            <Route path="/tools/pdf/to-word"      element={<PDFToWord />} />
            <Route path="/tools/pdf/compress"     element={<PDFCompress />} />
            <Route path="/tools/pdf/merge"        element={<MergePDF />} />
            <Route path="/tools/pdf/split"        element={<SplitPDF />} />
            <Route path="/tools/pdf/to-zip"       element={<PDFToZip />} />
            <Route path="/tools/pdf/to-jpg"       element={<PdfToJpg />} />

            {/* Image Tools */}
            <Route path="/tools/image/jpg-to-png"  element={<JpgToPng />} />
            <Route path="/tools/image/resize"      element={<ImageResize />} />
            <Route path="/tools/image/compress"    element={<ImageCompress />} />
            <Route path="/tools/image/remove-bg"   element={<RemoveBg />} />
            <Route path="/tools/image/png-to-jpg"  element={<PngToJpg />} />

            {/* Text Tools */}
            <Route path="/tools/text/word-counter"   element={<WordCounter />} />
            <Route path="/tools/text/case-converter" element={<CaseConverter />} />

            {/* Utility Tools */}
            <Route path="/tools/utility/qr-code"  element={<QrGenerator />} />
            <Route path="/tools/utility/resume-builder" element={<ResumeBuilder />} />

            {/*
              ADMIN PANEL — Secret URL, not linked anywhere on the website.
              Only you know this URL. Do NOT share it.
              URL: /dv-panel-83ca0bcf
              Change this URL in App.jsx and AdminLogin.jsx before going live.
            */}
            <Route path="/dv-panel-83ca0bcf"           element={<AdminLogin />} />
            <Route path="/dv-panel-83ca0bcf/dashboard" element={<AdminRoute><AdminDashboard /></AdminRoute>} />

            {/* 404 */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}